import { theme } from "themes/default/theme"
import { masterBreakPoint } from "themes/default/breakpoints"

export const styles = {
  inputBox: {
    border: `2px solid ${theme.palette.warning.main}`,
    borderRadius: 2.5,
    pr: 0,
    "& input": {
      minWidth: `100px`,
      pl: 1.5,
      pr: 0,
      py: 1,
      mr: 3.5,
      [masterBreakPoint]: {
        py: 0.5,
      },
    },
    "& textarea": {
      mr: 3.5,
    },
    "&.Mui-disabled input": {
      color: theme.palette.common.black,
      textFillColor: theme.palette.common.black,
    },
    "&.Mui-disabled textarea": {
      color: theme.palette.common.black,
      textFillColor: theme.palette.common.black,
    },
  },
  textField: {
    maxWidth: "100%",
    borderColor: "transparent",
    mb: 1,
    color: theme.palette.common.black,
    "& label.Mui-focused": {
      borderColor: "transparent",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "transparent",
      },
    },
    "& textarea": {
      color: theme.palette.common.black,
    },
  },
  textItem: {
    color: theme.palette.danger.main,
    fontWeight: 600,
  },
}
